module.exports = __webpack_public_path__ + "static/img/main_notification_icon_p.208dc22b.svg";